define('dataSource/shell/shellRegistry',['knockout', 'lodash'],
    function(ko, _) {
        'use strict';
        /**
         * observable for list of registries
         * @type {Array}
         */
        var shellRegistryList = ko.observableArray([]);
        /**
         * computed observable for number of loading dataSources for shell
         * @type {integer}
         */
        var isLoading = ko.computed({
            read: computeIsLoading,
            deferEvaluation: true
        }).extend({
            throttle: 500
        });

        return {
            isLoading: isLoading,
            push: addShellRegistry
        };

        /**
         * function to compute num of dataSources related to shell view are loading
         * @return {interger} number of dataSources related to shell view are loading
         */
        function computeIsLoading() {
            var isLoading =  _.reduce(shellRegistryList(), function(sum, loadingObs) {
                return sum + !! loadingObs();
            }, 0);
            return isLoading;
        }
        /**
         * function to add registry of isLoading observable
         * @param {ko.observable} loadingObs registed observable that holds
         * the logic that the corresponding datasource is currently loading or not
         */
        function addShellRegistry(loadingObs) {
            shellRegistryList.push(loadingObs);
        }
    });
